import React from "react";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

import defaultStyles from "./main.module.scss";

const BulletPointOnLeft = ({ doc, sliceStyles: styles = defaultStyles }) => {
  const {
    internal_link_id,
    top_header_text,
    header,
    bg_color,
    cta_link,
    cta_text,
    button_design,
    second_cta_link,
    second_cta_text,
    second_button_design,
  } = doc?.primary || {};
  const style = { backgroundColor: bg_color };
  const buttonStyles = {
    solid_background: styles.filledBtn,
    transparent_background: styles.transparentBtn,
    link_without_border: styles.linkWithoutBorder,
    "button-filled-beige": styles.buttonFilledBeige,
    "button-bordered-beige": styles.buttonBorderedBeige,
  };
  const classNameBtn = `${styles.button} ${buttonStyles[button_design]}`;
  const classNameBtnSecond = `${styles.button} ${buttonStyles[second_button_design]}`;
  return (
    <div className={styles.bulletPointOnLeftSlice} style={style}>
      {internal_link_id && <span id={internal_link_id} className={styles.linkId} />}
      <div className={styles.bulletPointsOnLeftContainer}>
        {checkContentPresence(top_header_text) && (
          <div className={styles.bulletPointsOnLeftTopHeaderText}>
            {textResolver(top_header_text, { convertLabelToModular: true })}
          </div>
        )}
        {checkContentPresence(header) && (
          <div className={styles.bulletPointsOnLeftTitle}>
            {textResolver(header, { convertLabelToModular: true })}
          </div>
        )}
        <div className={styles.bulletPointsOnLeftBlocksRow}>
          {doc?.items?.map(({ bullet, header, description, section_bg_color }) => {
            const backgroundStyle = { backgroundColor: section_bg_color };
            return (
              <div className={styles.bulletPointsOnLeftBlockHolder} key={header}>
                <div
                  className={styles.bulletPointsOnLeftBlockContentHolder}
                  style={backgroundStyle}
                >
                  <div className={styles.bulletPointsOnLeftBlockHeader}>
                    {checkContentPresence(bullet) && (
                      <div className={styles.bulletPointsOnLeftNumberBlock}>
                        <div className={styles.bulletPointsOnLeftNumberBlockHolder}>
                          {textResolver(bullet, { convertLabelToModular: true })}
                        </div>
                      </div>
                    )}
                    {checkContentPresence(header) && (
                      <div className={styles.bulletPointsOnLeftNumberTitle}>
                        {textResolver(header, { convertLabelToModular: true })}
                      </div>
                    )}
                  </div>
                  {checkContentPresence(description) && (
                    <div className={styles.bulletPointsOnLeftBlockDescription}>
                      {textResolver(description, { convertLabelToModular: true })}
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          <div className={styles.bulletPointsOnLeftButtonsRow}>
            {cta_link?.url && (
              <div className={styles.bulletPointsOnLeftButtonHolder}>
                <PrismicLinkTag
                  urlText={cta_text}
                  url={cta_link?.url}
                  target={cta_link?.target}
                  convertLabelToModular
                  className={classNameBtn}
                />
              </div>
            )}
            {second_cta_link?.url && (
              <div className={styles.bulletPointsOnLeftButtonHolder}>
                <PrismicLinkTag
                  urlText={second_cta_text}
                  url={second_cta_link?.url}
                  target={second_cta_link?.target}
                  convertLabelToModular
                  className={classNameBtnSecond}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulletPointOnLeft;
